// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContactSocialNetwork_wrapper__2pAs9","container":"ContactSocialNetwork_container__3rOmy","links":"ContactSocialNetwork_links__3AMp_"};